import React, { useState } from "react";

const Icon = ({ secCode, companyImageUrl }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const [useCompanyImageUrl, setUseCompanyImageUrl] = useState(false);
  const [isCompanyImageLoaded, setIsCompanyImageLoaded] = useState(true);

  // secCode も companyImageUrl もない場合は何も表示しない
  if (!secCode && !companyImageUrl) {
    return null;
  }

  // 画像のパスを設定（public フォルダから読み込み）
  const imageUrl = `/img/logo/${secCode}.png`;

  // 画像が読み込めない場合のエラー処理
  const handleError = () => {
    if (!useCompanyImageUrl && companyImageUrl) {
      setUseCompanyImageUrl(true); // secCode の画像がない場合、companyImageUrl を試す
    } else {
      setIsImageLoaded(false)
      setIsCompanyImageLoaded(false); // companyImageUrl も失敗したら非表示にする
    }
  };

  // 両方の画像が読み込めない場合は非表示
  if (!isImageLoaded || (!isCompanyImageLoaded && useCompanyImageUrl)) {
    return null;
  }

  return (
    <img
      src={useCompanyImageUrl ? companyImageUrl : imageUrl}
      alt={`Company Icon - ${secCode}`}
      onError={handleError} // 画像読み込みエラー時の処理
      className="w-full h-full object-contain"
    />
  );
};

export default Icon;
